<template lang="html">
  <div class="datepicker" v-show="show">
    <div class="head">
      <span @click.stop.prevent="yearHandle(1)"><img src="../assets/y_left_arrow.png" alt=""></span>
      <span v-if="!isYearTable" @click.stop.prevent="dateHandle(1)"> <img src="../assets/m_left_arrow.png" alt=""> </span>
      <span class="dateTitle"><span @click.stop.prevent="pickYear">{{year}}年</span><span>{{month}}月</span></span>
      <span v-if="!isYearTable" @click.stop.prevent="dateHandle(2)"><img src="../assets/m_right_arrow.png" alt=""></span>
      <span @click.stop.prevent="yearHandle(2)"><img src="../assets/y_right_arrow.png" alt=""></span>
    </div>
    <ul class="dayTable" v-if="!isYearTable">
      <li>日</li>
      <li>一</li>
      <li>二</li>
      <li>三</li>
      <li>四</li>
      <li>五</li>
      <li>六</li>
      <li @click.stop.prevent="chooseDate(index,item)" v-for="(item,index) in dateArr" :class="!item?'':currentIndex&&currentIndex==index?'date active':year==currentYear&&month==currentMonth&&item>currentDay?'date disabled':'date'">{{item}}</li>
    </ul>
    <ul class="yearTable" v-if="isYearTable">
      <li @click.stop.prevent="chooseYear(item)" :class="year==item?'active':item>currentYear?'disabled':''" v-for="item in yearTableArray">{{item}}</li>
    </ul>
  </div>
</template>

<script>
export default {
  name:'datepicker',
  data(){
    return{
      dateArr:[],
      year:'',
      month:'',
      day:'',
      currentYear:'',
      currentMonth:'',
      currentDay:'',
      currentIndex:'',
      isYearTable:false,
      yearTableArray:[]
    }
  },
  props:["show","type","index"],
  methods:{
    yearComputed(type){
      const Plus = 2;
      const Sub = 1;
      let copy = this.yearTableArray.concat()
      if(type==Plus){
        let lastChild = copy.pop()
        let arr = []
        for(let i = lastChild+1;i<=lastChild+15;i++){
          arr.push(i)
        }
        this.yearTableArray = arr
      }else{
        let firstChild = copy.shift()
        let arr = []
        for(let i = firstChild-15;i<=firstChild-1;i++){
          arr.push(i)
        }
        this.yearTableArray = arr
      }
    },
    chooseYear(year){
      if(year<=this.currentYear){
        this.year = year
        this.isYearTable = false
        this.dateArr=this.renderArray(this.year,this.month-1)
      }
    },
    getYearTableArray(year){
      let arr = [];
      let y = parseInt(year)
      for(let i = y-7;i<=y+7;i++){
        arr.push(i)
      }
      return arr
    },
    pickYear(){ //选择年份
      this.isYearTable = !this.isYearTable
      this.yearTableArray = this.getYearTableArray(this.year)
    },
    dateHandle(type){
      const Plus = 2
      const Sub=1
      if(type==Sub){
        this.month--;
        if(this.month<=0){
          this.month=12;
          this.year--
        }
        this.dateArr=this.renderArray(this.year,this.month-1)
      }else if (type==Plus) {
        this.month++;
        if(this.month>12){
          this.month=1;
          this.year++
          if(this.year>=this.currentYear){
            this.year = this.currentYear
          }
        }
        if(this.year >= this.currentYear&&this.month-1>=this.currentMonth){
          this.month=this.currentMonth
          return
        }
        this.dateArr=this.renderArray(this.year,this.month-1)
      }
    },
    yearHandle(type){
      const Plus = 2
      const Sub=1
      if(!this.isYearTable){
        if(type == Plus){
          this.year++
          if(this.year>=this.currentYear){this.year = this.currentYear}
        }else {
          this.year--
        }
        this.dateArr=this.renderArray(this.year,this.month-1)
      }else{
        this.yearComputed(type)
      }
    },
    formatTime(date){
      let time = date + '';
      return time.length == 2 ? time : '0' + time
    },
    chooseDate(index,day){
      if(this.year==this.currentYear&&this.month==this.currentMonth&&day>this.currentDay){
        return
      }else{
        this.currentIndex = index
        this.day = day
        let date = `${this.year}-${this.formatTime(this.month)}-${this.formatTime(this.day)}`
        // this.show=false
        if(this.type){
          this.$emit("getChildDate",{date,type:this.type})
        }else{
          this.$emit("getChildDate",{date:date,index:this.index})
        }

      }

    },
    renderArray: function(year, month) {
      let fullDay = new Date(year, month + 1, 0).getDate(); //当月总天数
      let startWeek = new Date(year, month, 1).getDay(); //当月第一天是周几
      let total = (fullDay + startWeek) % 7 == 0 ? (fullDay + startWeek) :
        fullDay + startWeek + (7 - (fullDay + startWeek) % 7); //元素总个数
      let eleTemp = [];
      for (let i = 0; i < total; i++) {
        if (i < fullDay + startWeek && i > startWeek - 1) {
          eleTemp[i] = i - startWeek + 1
        } else {
          eleTemp[i] = ""
        }
      }
      return eleTemp
    },
  },
  mounted(){
    const date = new Date()
    let year = date.getFullYear()
    let month = date.getMonth()+1
    let day = date.getDate()
    this.year = year
    this.month = month
    this.day = day
    this.currentYear = year
    this.currentMonth = month
    this.currentDay = day
    this.dateArr = this.renderArray(year,month-1)
  }
}
</script>

<style lang="css" scoped>
  .dateTitle span{
    margin:0 10px;
  }
  .dateTitle span:first-child:hover{
    color: orange;
  }
  .datepicker{
    position: absolute;
    width: 100%;
    top: 40px;
    left: 0;
    background: #fff;
    border: 1px solid #e2e2e2;
    z-index: 999999;
    min-width: 250px;
  }
  .head{display: flex;justify-content: space-around;align-items: center;font-weight: normal;padding: 10px 20px;align-items: center;font-size: 15px;color: #666;    border-bottom: 1px solid #e2e2e2;}
  .head span{cursor: pointer;display: inherit;align-items: center;}
  .head span img{
    width: 15px;
  }
  ul{display: flex;justify-content: space-between;padding-left: 0;padding:0 20px; flex-wrap: wrap;}
  ul li{list-style: none;width: calc(100% / 7);text-align: center;font-size: 14px;color: #333;line-height: 2;font-weight: 400;}
  .date{line-height: 2;color: #666;
  font-weight: normal;cursor: pointer;}
  .date:hover{background: rgb(238, 238, 238);}
  .date.disabled{
    color: #d2d2d2;
  }
  .date.active{color: #fff;background: #009688;}
  .yearTable li{
    width: calc(100% / 3)!important;
    line-height: 3;
    cursor: pointer;
  }
  .yearTable li.active:hover,.yearTable li.active{color: #fff;background: #009688;}
  .yearTable li.disabled{
    color: #d2d2d2;
  }
  .yearTable li:hover{background: rgb(238, 238, 238);}
  .yearTable li.disabled:hover{background: none;}
  .yearTable{justify-content: flex-start;}
</style>



// WEBPACK FOOTER //
// src/components/datepicker.vue